import { createContext } from "react";
import brand from "./brand.config";

export const CartContext = createContext(null);
export const AuthContext = createContext(null);
export const CartUIContext = createContext(null);
export const AdminContext = createContext(null);
export const BrandContext = createContext(brand);
export const SiteSettingsContext = createContext({ settings: null, refresh: () => {} });
